import { useEffect } from "react";

/**
 * Drives the server query behind a paginated table.
 *
 * Re-runs whenever the page or the filters change: it turns the page into
 * offset/limit, drops filters that are undefined, null or an empty string,
 * persists the page so a return visit lands where the user left off, and asks
 * the caller's lazy query for that slice.
 *
 * Only those three are dropped. An empty array is still sent, deliberately: the
 * multi-select filters (roles, skills, certifications) default to `[]`, the
 * server already reads an empty list as "no filter", and the legacy table sends
 * it the same way — so both sides of the feature flag issue the same query.
 * Passing a null `fetchData` disables it, which is how the wrapper hands the
 * job over to whichever table is on screen.
 */
export default function usePaginatedFetch({
  fetchData,
  pagination,
  filters,
  savePagination,
}) {
  useEffect(() => {
    if (fetchData && pagination) {
      const inputs = {
        offset: pagination.pageIndex * pagination.pageSize,
        limit: pagination.pageSize,
      };
      for (const key in filters) {
        if (
          filters[key] !== undefined &&
          filters[key] !== null &&
          filters[key] !== ""
        ) {
          inputs[key] = filters[key];
        }
      }
      if (savePagination) {
        savePagination(pagination);
      }
      fetchData({ variables: inputs });
    }
  }, [fetchData, pagination, filters, savePagination]);
}
